<div class="sam-hubspot-form">
  @if (heading()) {
    <h2 class="sam-hubspot-form__heading">{{ heading() }}</h2>
  }
  @if (intro()) {
    <p class="sam-hubspot-form__intro">{{ intro() }}</p>
  }
  <div class="sam-hubspot-form__target" [id]="targetId()"></div>
</div>
